<template>
   <div class="question-open">
       <input type="text" :name="question.id" v-model="questionAnswer" :placeholder="question.placeholder"
              :class="{'with-errors': hasErrors}">
       <div v-if="hasErrors">
           <ul class="text-yellow-700 text-sm">
               <li v-for="error in errors">
                   {{error}}
               </li>
           </ul>
       </div>
   </div>
</template>
<style scoped>
.with-errors{
    @apply border-2 border-yellow-500;
}
.question-open input{
    border: 1px solid #E6E6E6;
    background: #F8F8F8;
    border-radius: 8px;
    height: 50px;
    max-width: 577px;
    padding-left: 15px;
    padding-right: 15px;
    width: 100%;
    --tw-text-opacity: 1;
    color: rgba(57, 63, 68, var(--tw-text-opacity));
}
</style>
<script>
import { useStore } from 'vuex'
import { computed } from 'vue'

export default {
    name: "OpenQuestion",
    components:{

    },
    data() {
        return {

        }
    },
    computed: {
        questionAnswer: {
            get () {
                return this.$store.getters.answerForQuestion(this.question.id);
            },
            set (value) {
                this.$store.commit('setAnswer', {questionId: this.question.id, answer: value});
            }
        },
        errors: {
            get () {
                return this.$store.getters.errorsForQuestion(this.question.id);
            }
        },
        hasErrors(){
            if(this.errors === null){
                return false;
            }
            return this.errors.length > 0;
        }
    },
    mounted() {

    },
    setup(props){
        const store = useStore()

        return {

        }
    },
    methods:{

    },
    props: {
        question: {
            type: Object
        }
    }
}
</script>
